import React from 'react'
import "./contact.css";
import { FaHome, FaMailBulk, FaPhone } from 'react-icons/fa';
const ContactComponent = () => {
  return (
    <div className="container">
       <h1 className="contact-heading">Get in Touch</h1>
          <div className="contact-info">
            <div className="location">
                <div className="contact-icon">
                <FaHome size={20} style={{ color:"#fff", marginRight:"2rem"}}/>
                <FaPhone size={20} style={{ color:"#fff", marginRight:"2rem"}}/> 
                <FaMailBulk size={20} style={{ color:"#fff", marginRight:"2rem"}}/>
                </div>
                <div className="location-info">
                <div className="address">
                    <h4> 
                    Sector 10, Uttara, Dhaka, Bangladesh
                    </h4>
                    
                </div>
                <div className="phone">
                    <h4>
                        
                        +880 1646 297 867
                      </h4>
                </div>
                <div className="gmail">
                    <h4>
                        
                        rayhanhabib56@gmail.com
                    </h4>
                </div>
                </div>
            </div>
            <div className="contact-form">
              <form action="">
                  <label htmlFor="">Your Name</label>
                  <input type="text"></input>
                  <label htmlFor="">Your Email</label>
                  <input type="email"></input>
                  <label htmlFor="">Subject</label>
                  <input type="text"></input>
                  <label htmlFor="">Message</label>
                  <textarea rows="6" placeholder="Type you Message here..."/>
                  <div className="submit">
                  <button className="btn">Submit</button>
                  </div>
              </form>
            </div>
          </div>
       </div>
  )
}

export default ContactComponent;